import { Role } from "@linkfluence/models/role";
import { RolesAPI } from "@radarly/api/roles";
import { RolesRepo } from "./RolesRepo";

interface Dependencies {
  rolesAPI: RolesAPI;
}

export class ConnectedRolesRepo implements RolesRepo {
  private rolesAPI: RolesAPI;
  public constructor(dependencies: Dependencies) {
    this.rolesAPI = dependencies.rolesAPI;
  }
  public async attachUserRole(pid: number, uid: number, role: Role) {
    return await this.rolesAPI.attachUserRole(pid, uid, role);
  }
  public async detachUserRole(pid: number, uid: number) {
    return await this.rolesAPI.detachUserRole(pid, uid);
  }
  public async setUserWorkspaces(
    pid: number,
    uid: number,
    workspaceIds: number[]
  ) {
    return await this.rolesAPI.setUserWorkspaces(pid, uid, workspaceIds);
  }
}
